import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { colors as C } from "@/lib/theme";
import { Ion } from "@/components/Ion";
import { Screen, Spinner } from "@/components/Orig";

const MSG = { connected: ["success", "Google Drive connected."], cancelled: ["error", "Google sign-in was cancelled."], failed: ["error", "Couldn't connect Google Drive. Make sure you allow Drive access."] };

const DriveCard = ({ st, reload }) => {
  const connect = async () => {
    const framed = window.self !== window.top;
    const tab = framed ? window.open("", "_blank") : null;
    try {
      const r = await api("/marketing-videos/drive/connect", { method: "POST", body: { origin: window.location.origin } });
      if (tab) tab.location.href = r.authorization_url; else window.location.href = r.authorization_url;
    } catch (e) { tab?.close(); toast.error(e.message); }
  };
  const disconnect = async () => { if (!window.confirm("Disconnect the video Drive? Franchisees won't be able to upload until you reconnect.")) return; await api("/marketing-videos/drive/disconnect", { method: "POST" }); reload(); };
  return (
    <div className="mb-4 rounded-xl border p-4" style={{ background: C.card, borderColor: C.border }} data-testid="mv-drive-card">
      <p className="text-[10px] font-extrabold tracking-[1.4px]" style={{ color: C.accent }}>CORPORATE GOOGLE DRIVE</p>
      {st.ready ? <>
        <p className="mt-1 text-sm" style={{ color: C.text }} data-testid="mv-drive-email">Connected as <b>{st.email}</b>. Videos go to the "ALR Franchise Marketing Videos" folder, with one folder per franchise.</p>
        <button onClick={disconnect} className="mt-3 rounded-[10px] border px-3 py-2 text-xs font-bold" style={{ borderColor: C.border, color: C.text }} data-testid="mv-drive-disconnect">Disconnect</button>
      </> : <>
        <p className="mt-1 text-sm" style={{ color: C.text }}>{st.status === "reconnect_required" ? "Google sign-in expired. Reconnect to resume uploads." : "Connect the corporate Google account that should receive franchise videos."}</p>
        <button onClick={connect} className="mt-3 rounded-[10px] px-4 py-2 text-sm font-extrabold text-black" style={{ background: C.accent }} data-testid="mv-drive-connect">Connect Google Drive</button>
      </>}
    </div>
  );
};

export default function AdminMarketingVideos() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [d, setD] = useState(null);
  const load = useCallback(async () => {
    const [st, rows] = await Promise.all([api("/marketing-videos/drive/status"), api("/marketing-videos/admin/uploads")]);
    setD({ st, rows });
  }, []);
  useEffect(() => { load().catch((e) => toast.error(e.message)); const m = MSG[params.get("drive")]; if (m) toast[m[0]](m[1]); }, [load, params]);
  return (
    <Screen testId="admin-marketing-videos-page">
      <div className="mx-auto max-w-3xl px-4 pb-16">
        <div className="flex items-center gap-3 py-3">
          <button onClick={() => navigate(-1)} aria-label="Back" data-testid="amv-back" className="flex h-[38px] w-[38px] items-center justify-center rounded-[10px] border" style={{ background: C.card, borderColor: C.border }}><Ion name="chevron-back" size={22} color={C.text} /></button>
          <div className="flex-1"><p className="text-[9px] font-extrabold tracking-[1.6px]" style={{ color: C.accent }}>ADMIN · MARKETING</p><h1 className="text-lg font-extrabold" data-testid="page-title">Franchise Marketing Videos</h1></div>
        </div>
        {!d ? <Spinner /> : <>
          <DriveCard st={d.st} reload={load} />
          <p className="mb-2 text-[10px] font-extrabold tracking-[1.4px]" style={{ color: C.accent }}>{d.rows.length} UPLOADED VIDEO{d.rows.length === 1 ? "" : "S"}</p>
          {d.rows.map((r) => (
            <div key={r.id} className="mb-2 rounded-lg border px-3 py-2" style={{ borderColor: C.border, background: C.card }} data-testid={`amv-row-${r.id}`}>
              <p className="text-sm font-bold" style={{ color: C.text }}>{r.franchise} · {r.filename}</p>
              <p className="text-xs" style={{ color: C.textSecondary }}>{r.description}</p>
              <p className="mt-1 text-xs" style={{ color: C.textSecondary }}>{r.user_name} ({r.user_email}) · {new Date(r.uploaded_at).toLocaleString()} · usage consent ✓
                {r.drive_link && <> · <a href={r.drive_link} target="_blank" rel="noopener noreferrer" className="font-bold underline" style={{ color: C.accent }} data-testid={`amv-open-${r.id}`}>Open in Drive</a></>}</p>
            </div>
          ))}
        </>}
      </div>
    </Screen>
  );
}
